var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssistBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51481 0L3.72548 3.71596L0.0175733 4.59972L3.74808 5.38567L4.63531 9.08007L5.42369 5.36316L9.13225 4.48065L5.40204 3.6944L4.51481 0ZM14.304 0.168947L11.3901 3.07131L12.9795 4.65441L15.893 1.75195L14.304 0.168947ZM10.3303 4.12679L0 14.4169L1.5892 16L11.9195 5.70992L10.3302 4.12679H10.3303ZM13.5335 5.96961L13.1119 7.95493L11.1304 8.42776L13.1235 8.84745L13.5972 10.8212L14.0185 8.83591L16 8.36307L14.0069 7.94335L13.5335 5.96961ZM10.2833 9.57713L9.81867 11.7665L7.63419 12.2862L9.83152 12.749L10.3539 14.9256L10.8185 12.7362L13.003 12.2159L10.806 11.7528L10.2833 9.57713Z",
    fill: "#4F5662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssistBooking);
export default __webpack_public_path__ + "static/media/icon-assist-booking.ccd509638ca8673e8f21a96aab0cc79f.svg";
export { ForwardRef as ReactComponent };